import { faPenToSquare, faSquareExclamation, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import _ from 'lodash';
import React, { Fragment, useState } from 'react';
import {Link, useLocation} from "react-router-dom";
import { Can } from "../../../ability-context";
import { ARTICLE_KEY } from "../../../api/public-voissa/articles";
import {
    COMMENT_KEY,
    COMMENTS_KEY, createComment, createSubComment,
    deleteComment, deleteSubComment, fetchComment,
    fetchComments,
    updateComment, updateSubComment
} from "../../../api/public-voissa/comments";
import { HOME_FEED_FOR_YOU_KEY, HOME_FEED_KEY, HOME_FEED_MEDIAS_KEY } from "../../../api/public-voissa/home-feed";
import { MEDIA_KEY } from "../../../api/public-voissa/medias";
import {
    USER_CURRENT_KEY, USER_FIL_ACTUALITY_KEY, USER_FRIENDS_KEY,
    fetchUserFriends, USER_STATUS_KEY, USER_NOTIFICATION_STATUS_KEY
} from "../../../api/public-voissa/users";
import { COMMENT } from "../../../const/toasts";
import useReport, { REPORT_KINDS } from "../../../hooks/useReport";
import createLink from "../../../libs/createLink";
import { toastError } from "../../../libs/toast";
import Drawer from "../../components2/Drawer/Drawer";
import MenuList, { MenuListItem } from '../../components2/MenuList/MenuList';
import Button from '../../components2/UI/Button/Button';
import EncourageSignup from "../../components2/encourageSignup/EncourageSignup";
import Alert from "../Alert/Alert";
import { PageLoader } from "../Loader";
import Report from '../Report/Report';
import Comment from './Comment';
import "./Comments.scss";
import CommentEditor from "./components/CommentEditor/CommentEditor";
import moment from "moment-timezone";
import {STATUS_KEY} from "../../../api/public-voissa/status";


const initialSubCommentAnswer = {
    owner: {},
    commentId: "",
    replyToId:""
};

const Comments = ({
        parent = {},
        commentsAllowed = false,
        type = "",
        sort = "-createdAt",
        limit = 10,
        previewSubComment = 0,
        className = "column",
        onFocus = () =>{},
        onBlur = () =>{}
    }) =>{
    const queryClient = useQueryClient();

    const filter = {
        page: 1,
        limit,
        sort
    };
    const location = useLocation();
    const commentId = location.state?.commentId;
    const dataCurrentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const currentUserId = _.get(dataCurrentUser, '_id');
    const isCurrentUser = !!currentUserId;

    const [subCommentAnswer, setSubCommentAnswer] = useState(initialSubCommentAnswer);
    const [currentCommentEdit, setCurrentCommentEdit] = useState({});
    const [toggleSignIn, setToggleSignIn] = useState(false);
    const [toggleCommentOption, setToggleCommentOption] = useState(null);
    const [toggleAlertDelete, setToggleAlertDelete] = useState(false);
    const [toggleReport, setToggleReport] = useState(false);


    const {handleReport} = useReport({parentKind : toggleCommentOption?.parentCommentId ? REPORT_KINDS.SUB_COMMENT : REPORT_KINDS.COMMENT, parentId : parent?._id, commentKindParent : type, commentId : toggleCommentOption?._id, subCommentId : toggleCommentOption?.parentCommentId, onSuccess : ()=> {
        setToggleReport(false);
        setToggleCommentOption(null);
    }});

    const {data : dataFriends} = useQuery(
        [USER_FRIENDS_KEY, currentUserId, {limit: false}],
        ()=> fetchUserFriends(currentUserId, {limit: false}),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!isCurrentUser,
            placeholderData : {
                data : [],
                total : 0
            },
            select : (data) =>{
                return {
                    friends : data.data || [],
                    total : data.total
                }
            }
        }
    );

    let {friends = []} = dataFriends || {};

    const {isSuccess : isSuccessComments, isFetching : isFetchingComments, data : dataComments, fetchNextPage : fetchNextPageComments, hasNextPage : hasNextPageComments} = useInfiniteQuery(
        [COMMENTS_KEY, parent._id],
        ({pageParam = 1}) => fetchComments(type, parent._id, {...filter, page : pageParam}),
        {
            enabled : !!type && !!parent._id,
            getNextPageParam: (lastPage, pages) => lastPage && lastPage.more ? pages.length +1 : undefined,
        }
    );

    const {
        mutate : mutateCreateComment,
    } = useMutation((data) => createComment(type, parent._id, data),{
        onSuccess: async (data) =>{
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id]);
            if(previousValue){
                let newPagesArray = previousValue?.pages || [];
                if(_.get(newPagesArray, '[0].data')){
                    newPagesArray[0].data = [...newPagesArray[0].data,data];
                    newPagesArray[0].total = newPagesArray[0].total +1;
                }
                queryClient.setQueryData([COMMENTS_KEY, parent._id], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
        },
        onError: () =>{
            updateCommentCount(false);
            toastError(COMMENT.ERROR.CREATE);
        }
    });

    const {
        mutate : mutateCreateSubComment,
    } = useMutation((comment) => createSubComment(type, parent._id, comment.parentCommentId, comment.data),{
        onSuccess: async (data) =>{
            let commentParentId = data.parentId;
            await queryClient.invalidateQueries([COMMENT_KEY, parent?._id, commentId]);
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id, commentParentId]);
            //si il y a déjà des subCommentaires on met a jour
            if(previousValue){

                const currentPage = previousValue?.pages?.length - 1 || 0;
                let newPagesArray = previousValue?.pages || [];
                if(_.get(newPagesArray, '[0].data')){
                    newPagesArray[currentPage].data = [...newPagesArray[currentPage].data,data];
                    newPagesArray[currentPage].total = newPagesArray[currentPage].total +1;
                }
                queryClient.setQueryData([COMMENTS_KEY, parent._id, commentParentId], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            //sinon on update le parent pour prevenir qu'il y a des subCommentaires
            else{
                const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id]);
                if(previousValue){
                    const newPagesArray = previousValue?.pages.map((page) => {
                            page.data = page.data.map((item) => {
                                if(item._id.toString() === commentParentId.toString()){
                                    item = {...item, subComments : true};
                                }
                                return item;
                            });
                            return page;
                        }
                    ) ?? []
                    queryClient.setQueryData([COMMENTS_KEY, parent._id], oldData => ({
                        pages: newPagesArray,
                        pageParams: oldData.pageParams,
                    }));
                }
            }

        },
        onError: () =>{
            updateCommentCount(false);
            toastError(COMMENT.ERROR.CREATE);
        }
    });

    const {
        mutate : mutateUpdateComment,
    } = useMutation((comment) => updateComment(type, parent._id, comment.id, comment.data),{
        onSuccess: async (data) =>{
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id]);
            if(previousValue){
                const newPagesArray = previousValue?.pages.map((page) => {
                        page.data = page.data.map((item) => {
                            if(item._id.toString() === data._id.toString()){
                                item = {...item, ...data};
                            }
                            return item;
                        });
                        return page;
                    }
                ) ?? []

                queryClient.setQueryData([COMMENTS_KEY, parent._id], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            await queryClient.invalidateQueries([COMMENT_KEY, parent._id, data._id]);

        },
        onError: () =>{
            toastError(COMMENT.ERROR.UPDATE);
        }
    });

    const {
        mutate : mutateUpdateSubComment,
    } = useMutation((comment) => updateSubComment(type, parent._id, comment.parentCommentId, comment.id, comment.data),{
        onSuccess: async (data) =>{
            let commentParentId = data.parentId;
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id, commentParentId]);
            if(previousValue){
                const newPagesArray = previousValue?.pages.map((page) => {
                        page.data = page.data.map((item) => {
                            if(item._id.toString() === data._id.toString()){
                                item = {...item, ...data};
                            }
                            return item;
                        });
                        return page;
                    }
                ) ?? []

                queryClient.setQueryData([COMMENTS_KEY, parent._id, commentParentId], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            await queryClient.invalidateQueries([COMMENT_KEY, parent._id, commentParentId, data._id]);

        },
        onError: () =>{
            toastError(COMMENT.ERROR.UPDATE);
        }
    });


    const {
        mutate : mutateDeleteComment,
    } = useMutation((commentId) => deleteComment(type, parent._id, commentId),{
        onSuccess: async (data) =>{
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id]);
            if(previousValue){
                const newPagesArray = previousValue?.pages.map((page) => {
                        page.data = page.data.filter((item) => item._id.toString() !== data._id.toString());
                        page.total = page.total - 1;
                        return page;
                    }
                ) ?? []

                queryClient.setQueryData([COMMENTS_KEY, parent._id], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            await queryClient.invalidateQueries([COMMENT_KEY, parent._id, commentId]);
        },
        onError: () =>{
            updateCommentCount();
            toastError(COMMENT.ERROR.DELETE);
        }
    });

    const {
        mutate : mutateDeleteSubComment,
    } = useMutation((data) => deleteSubComment(type, parent._id, data.commentId, data.subCommentId),{
        onSuccess: async (data) =>{
            let commentParentId = data.parentId;
            const previousValue = queryClient.getQueryData([COMMENTS_KEY, parent._id, commentParentId]);
            if(previousValue){
                const newPagesArray = previousValue?.pages.map((page) => {
                        page.data = page.data.filter((item) => item._id.toString() !== data._id.toString());
                        page.total = page.total - 1;
                        return page;
                    }
                ) ?? []

                queryClient.setQueryData([COMMENTS_KEY, parent._id, commentParentId], oldData => ({
                    pages: newPagesArray,
                    pageParams: oldData.pageParams,
                }));
            }
            await queryClient.invalidateQueries([COMMENT_KEY, parent._id, commentParentId, data._id]);
        },
        onError: () =>{
            updateCommentCount();
            toastError(COMMENT.ERROR.DELETE);
        }
    });

    const {isSuccess : isSuccessComment,data : dataComment} = useQuery(
        [COMMENT_KEY, parent?._id, commentId],
        ()=> fetchComment(type, parent?._id, commentId),
        {
            enabled : !!commentId,

        }
    );


    function updateCommentCount(increase = true) {
        const increment = increase ? 1 : -1;

        const updateItemCounts = (item) => {
            if ((item._id.toString() === parent?._id?.toString()) || item._id.toString() === parent?.publicationId?.toString()) {
                return {
                    ...item,
                    count: {
                        ...item.count,
                        comment: item.count.comment + increment
                    },
                    updatedAt: item?.publicationType === "Status" ? moment() : item.updatedAt
                };
            }
            return item;
        };

        const updatePagesData = (pages) => pages.map(page => ({
            ...page,
            data: page.data.map(updateItemCounts)
        }));

        const updateDataInCache = (key, isUpdateTime = false) => {
            const previousData = queryClient.getQueryData(key);

            if (previousData?.pages) {
                const newData = {
                    ...previousData,
                    pages: updatePagesData(previousData.pages),
                    pageParams: [...previousData.pageParams]
                };
                queryClient.setQueryData(key, newData);
            } else if (Array.isArray(previousData?.data)) {
                if (previousData) {
                    const newData = {
                        ...previousData,
                        data: previousData.data.map(updateItemCounts)
                    };
                    queryClient.setQueryData(key, newData);
                }
            } else if(previousData) {
                const updatedData = {
                    ...previousData,
                    count: {
                        ...previousData.count,
                        comment: previousData.count.comment + increment
                    },
                    updatedAt : isUpdateTime ? new Date() : previousData?.updatedAt
                };

                queryClient.setQueryData(key, updatedData);
            }
        };

        // Handle updates based on the type of parent
        if (["Media", "Status", "Article"].includes(parent?.publicationType)) {
            updateDataInCache([HOME_FEED_FOR_YOU_KEY]);
            updateDataInCache([USER_FIL_ACTUALITY_KEY, parent?.owner?._id]);
            updateDataInCache([STATUS_KEY, parent?._id], true);
        }else if (parent?.kind === "status") {
            updateDataInCache([HOME_FEED_FOR_YOU_KEY]);
            updateDataInCache([USER_FIL_ACTUALITY_KEY, parent?.owner?._id]);
            updateDataInCache([USER_STATUS_KEY, parent?._id]);
            updateDataInCache([USER_NOTIFICATION_STATUS_KEY, parent?.publicationId]);
        }
        else if (parent?.kind === "article") {
            updateDataInCache([ARTICLE_KEY, parent._id], [ARTICLE_KEY, parent._id, {slug: parent?.slug}]);
        } else if (["gallery", "video"].includes(parent?.kind)) {
            updateDataInCache([HOME_FEED_KEY]);
            updateDataInCache([MEDIA_KEY, parent._id]);

            // Update all queries that use HOME_FEED_MEDIAS_KEY
            queryClient.getQueryCache().findAll([HOME_FEED_MEDIAS_KEY]).forEach(query => {
                updateDataInCache(query.queryKey);
            });
        }
    }

    function handleSubmit(value) {
        updateCommentCount();
        if(subCommentAnswer.commentId){
            mutateCreateSubComment({parentCommentId : subCommentAnswer.commentId,  data : {...value, replyToId : subCommentAnswer?.replyToId}});
            scrollToComment(`comment_${subCommentAnswer.commentId}`)

        } else {
            mutateCreateComment(value);
            setSubCommentAnswer(initialSubCommentAnswer);
            scrollToComment()
        }
        setSubCommentAnswer(initialSubCommentAnswer);
    }

    function handleSubmitEdit({
            parentCommentId,
            commentId,
        }, contentState) {
        if (parentCommentId) {
            mutateUpdateSubComment({id : commentId, parentCommentId, data : contentState});
        }
        else {
            mutateUpdateComment({id : commentId, data : contentState});
        }
        setCurrentCommentEdit({});

    }

    function updateSort(data){
        let pages = data.map((page, index) => {
            page.data = _.orderBy(page.data, ['createdAt'], ['desc']);
            page.pageNumber = index;
            return page;
        } )
        pages = _.orderBy(pages, ['pageNumber'], ['asc']);
        return pages;
    }

    function handleDelete(comment){
        updateCommentCount(false);
        if(comment.isSubComment) {
            mutateDeleteSubComment({commentId : comment.parentId,subCommentId : comment?._id});
        }
        else{
            mutateDeleteComment(comment?._id);
        }
        setToggleAlertDelete(false);
        setToggleCommentOption(null);
    }

    function handleEdit(comment){
        setCurrentCommentEdit({
            parentId: comment.parentId,
            commentId: comment._id,
            text: comment.text,
            mentions: comment.mentions,
            commentType: type,
            parentCommentId: comment.parentCommentId
        })
        setToggleCommentOption(null);
    }


    let canOptions = {
        subject: parent,
        modelName: "Comment",
        action: "create",
        passThrough: true
    };

    let total = _.get(dataComments,'pages[0].total') || 0;

    let data = [];
    if(_.get(dataComments,'pages')){
        data = updateSort(dataComments.pages);
    }

    function scrollToComment(id) {
        if(id){
            let elementComments = document.getElementById(id);
            const offset = 50;
            const bodyRect = 0;
            const elementRect = elementComments.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;
            elementComments.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
        else{
            let elementComments = document.getElementById("comments-list");
            elementComments.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <>
            <div className="v3-comments">
                <div className="comments-list" id={"comments-list"}>
                    {!isSuccessComments ? <PageLoader /> : null}
                    {isSuccessComments && total === 0 ? (
                        <div className={"no-content"}>Aucun commentaire</div>
                    ) : null}

                    {isSuccessComment && (
                        <Comment
                            key={dataComment._id}
                            comment={dataComment}
                            currentUser={dataCurrentUser}
                            parentId={parent._id}
                            commentId={dataComment._id}
                            commentsInitialized={isSuccessComment}
                            deleteSubComment={(commentId, subCommentId)=>mutateDeleteSubComment({commentId, subCommentId})}
                            subCommentAnswer={(commentId, ownerOfSubComment, replyToId) => setSubCommentAnswer({owner: ownerOfSubComment, commentId, replyToId})}
                            commentType={type}
                            hasSubComments={dataComment.subComments}
                            setToggleSignIn={(status) => setToggleSignIn(status)}
                            previewSubComment={previewSubComment}
                            setToggleCommentOption={setToggleCommentOption}
                            ownerPublish={parent?.owner}
                            highlighted={true}
                        />
                    )}

                    {isSuccessComments && data.map((group, i) => (
                        <Fragment key={i}>
                            {group.data.map(comment => (
                                comment?._id?.toString() !== dataComment?._id?.toString() && (
                                    <Comment
                                        key={comment._id}
                                        comment={comment}
                                        currentUser={dataCurrentUser}
                                        parentId={parent._id}
                                        commentId={comment._id}
                                        commentsInitialized={isSuccessComments}
                                        deleteSubComment={(commentId, subCommentId)=>mutateDeleteSubComment({commentId, subCommentId})}
                                        subCommentAnswer={(commentId, ownerOfSubComment, replyToId) => setSubCommentAnswer({owner: ownerOfSubComment, commentId, replyToId})}
                                        commentType={type}
                                        hasSubComments={comment.subComments}
                                        setToggleSignIn={(status) => setToggleSignIn(status)}
                                        previewSubComment={previewSubComment}
                                        setToggleCommentOption={setToggleCommentOption}
                                        ownerPublish={parent?.owner}
                                    />
                                )
                            ))}
                        </Fragment>
                    ))}
                    {hasNextPageComments && (
                        <div className="more-comments">
                           <Button  onClick={() => fetchNextPageComments()} loading={isFetchingComments}>Voir plus de commentaires</Button>
                        </div>
                    )}
                </div>
                {commentsAllowed ? (
                    <Can {...canOptions}>
                        {can => (
                            <CommentEditor
                                mentions={friends}
                                onSubmit={handleSubmit}
                                onSubmitEdit={handleSubmitEdit}
                                onCancelRespond={() => {
                                    setSubCommentAnswer(initialSubCommentAnswer);
                                }}
                                onCancelEdit={() => {
                                    setCurrentCommentEdit({})
                                }}
                                onBlur={() => onBlur()}
                                onFocus={() => onFocus()}
                                edit={currentCommentEdit}
                                respondMention={subCommentAnswer.owner}
                                cannot={!can}
                            />)}
                    </Can>
                ) : (
                    <div className="close-comments">
                        {isCurrentUser ? "Commentaires fermés par l’auteur" : <span>Veuillez vous <Link
                            to={createLink("signin")}>connecter</Link> pour publier un commentaire</span>}
                    </div>
                )}
            </div>
            <EncourageSignup toggle={toggleSignIn} handleClose={() => setToggleSignIn(false)}/>
            <Drawer
                    open={toggleCommentOption}
                    headContent="Options du commentaire"
                    handleClose={() => setToggleCommentOption(null)}
                    xsmall
                >
                    <MenuList style={{padding:'10px'}}>
                        <Can action={"update"} subject={toggleCommentOption} modelName="Comment">
                            <MenuListItem icon={faPenToSquare} onClick={() => handleEdit(toggleCommentOption)}>Editer</MenuListItem>
                        </Can>
                        <Can action={"report"} subject={toggleCommentOption} modelName="Comment">
                            <MenuListItem icon={faSquareExclamation} onClick={() =>{setToggleReport(true)}}>Signaler</MenuListItem>
                        </Can>
                        <Can action={"delete"} subject={toggleCommentOption} modelName="Comment">
                            <MenuListItem icon={faTrash} onClick={() => setToggleAlertDelete(true)}>Supprimer</MenuListItem>
                        </Can>
                    </MenuList>
                </Drawer>
            <Drawer
                open={toggleAlertDelete}
                handleClose={()=>setToggleAlertDelete(false)}
                headContent={"Attention"}
            >
                <Alert
                    text="Voulez vous vraiment supprimer ce commentaire ?"
                    handleClose={() => setToggleAlertDelete(false)}
                    handleDelete={() =>handleDelete(toggleCommentOption)}
                />
            </Drawer>
            <Drawer
                headContent="Signaler un commentaire"
                open={toggleReport}
                handleClose={()=>setToggleReport(false)}>
                <Report
                    handleReport={handleReport}
                    handleClose={()=> {
                        setToggleReport(false);
                        setToggleCommentOption(null);
                    }}
                />
            </Drawer>
        </>
    )
};

export default Comments;